/** Font identifier (from font data) to bundled TTF URL for @font-face / opentype. */

import antaresTtf from '../assets/fonts/antares.ttf';
import electraTtf from '../assets/fonts/electra.ttf';
import himaliaTtf from '../assets/fonts/himalia.ttf';
import juwelTtf from '../assets/fonts/juwel.ttf';
import polarisTtf from '../assets/fonts/polaris.ttf';
import saphirTtf from '../assets/fonts/saphir.ttf';
import titaniaTtf from '../assets/fonts/titania.ttf';
import romanoTtf from '../assets/fonts/romano.ttf';
import centuryTtf from '../assets/fonts/century.ttf';
import scaligeroTtf from '../assets/fonts/scaligero.ttf';
import modernoTtf from '../assets/fonts/moderno.ttf';
import cataneoTtf from '../assets/fonts/cataneo.ttf';
import murrayHillTtf from '../assets/fonts/murrayHill.ttf';
import gabyProTtf from '../assets/fonts/gabyPro.ttf';
import luxorTtf from '../assets/fonts/luxor.ttf';

export const FONT_IDENTIFIER_TO_TTF: Record<string, string> = {
  antares: antaresTtf,
  electra: electraTtf,
  himalia: himaliaTtf,
  juwel: juwelTtf,
  polaris: polarisTtf,
  saphir: saphirTtf,
  titania: titaniaTtf,
  romano: romanoTtf,
  century: centuryTtf,
  scaligero: scaligeroTtf,
  moderno: modernoTtf,
  laurina: cataneoTtf,
  musica: murrayHillTtf,
  sirius: gabyProTtf,
  askella: antaresTtf,
  luxor: luxorTtf,
};

export function getFontUrl(fontIdentifier: string): string | null {
  // 'saphir milled' -> 'saphir'
  const fontIdentifierWithoutSuffix = fontIdentifier.split(' ')[0];
  return FONT_IDENTIFIER_TO_TTF[fontIdentifierWithoutSuffix] ?? null;
}

export function createFontFacesCss(): string {
  return Object.entries(FONT_IDENTIFIER_TO_TTF)
    .map(([family, url]) => `@font-face { font-family: '${family}'; src: url('${url}') format('truetype'); }`)
    .join('\n');
}
